import { mapState, mapMutations, mapActions } from 'vuex';

import Interface from '@components/ui/interface.vue';
import Fastbuy from '@components/ui/fastBuy.vue';
import SecondMenu from '@components/second-menu/script.js';

export default {
  data: function() {
    return {
      leftMenuVisible: true,
      subList: false,
    };
  },
  components: {
    Interface,
    Fastbuy,
    'second-menu-cmp': SecondMenu,
  },
  computed: {
    ...mapState('params', ['auth', 'leftMenu', 'mobile']),
    activePath: function() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions('api', ['logOut']),
    ...mapMutations('params', [
      'toogleUserMenu',
      'closeleftMenu',
      'toggleRightMenu',
      'toogleFeedack',
      'closeleftMenu',
      'setAuthOff',
    ]),
    toogleSubList: function(id) {
      this.$refs[id].classList.toggle('open');
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/left-menu/script.js